export default __webpack_public_path__ + "static/media/logout.62bd03c8.svg";